var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 132,
    viewBox: "0 0 221 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 132C0.5 132 26.6874 88 109.408 88C196.935 88 220.5 132 220.5 132H0.5Z",
    fill: "url(#paint0_linear_11057_321499)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.44 54.3489C217.449 52.6047 216.635 50.9585 215.243 49.9073C213.851 48.8561 212.045 48.5231 210.37 49.0089C209.301 44.9892 205.508 42.3106 201.362 42.6473C197.217 42.9839 193.906 46.2393 193.5 50.3789C192.895 50.1537 192.255 50.0386 191.61 50.0389C188.848 50.0376 186.509 52.0736 186.13 54.8089V54.8789C186.125 54.9554 186.125 55.0323 186.13 55.1089C186.117 55.2686 186.117 55.4291 186.13 55.5889C186.13 57.0563 186.714 58.4634 187.754 59.4992C188.793 60.535 190.202 61.1142 191.67 61.1089H211.5C213.259 61.1107 214.921 60.2985 216 58.9089C217.091 57.6541 217.612 56.0027 217.44 54.3489Z",
    fill: "url(#paint1_linear_11057_321499)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8899 23.7188C46.8899 22.2504 46.3059 20.8424 45.2666 19.805C44.2274 18.7676 42.8182 18.1862 41.3499 18.1888C40.8317 18.1854 40.316 18.2595 39.8199 18.4088C38.7343 14.4123 34.9574 11.7548 30.8291 12.0827C26.7008 12.4106 23.3908 15.6311 22.9499 19.7488C22.3441 19.5277 21.7047 19.4127 21.0599 19.4088C18.3022 19.4126 15.9688 21.4474 15.5899 24.1788V24.2488V24.4788C15.5899 24.6088 15.5899 24.7688 15.5899 24.9588C15.5872 26.4254 16.1693 27.8325 17.2072 28.8685C18.2452 29.9046 19.6533 30.4842 21.1199 30.4788H40.9399C42.6969 30.4822 44.3558 29.6693 45.4299 28.2788C46.5282 27.0273 47.057 25.3756 46.8899 23.7188Z",
    fill: "url(#paint2_linear_11057_321499)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3904 54.4188H158.39C162.256 54.4188 165.39 57.5528 165.39 61.4188V122.349C165.39 125.696 162.677 128.409 159.33 128.409H62.5004C59.1536 128.409 56.4404 125.696 56.4404 122.349V61.3888C56.4568 57.554 59.5556 54.4462 63.3904 54.4188Z",
    fill: "url(#paint3_linear_11057_321499)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M165.5 71.0088H56.3096C51.6296 71.0088 48.9596 75.3588 49.3996 80.3888L54.8796 120.619C55.0996 124.867 58.5283 128.244 62.7796 128.399H159.04C163.291 128.244 166.72 124.867 166.94 120.619L172.42 80.3888C172.86 75.3388 170.19 71.0088 165.5 71.0088Z",
    fill: "url(#paint4_linear_11057_321499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11057_321499",
    x1: 25.292,
    y1: 89.1148,
    x2: 25.292,
    y2: 123.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11057_321499",
    x1: 178.401,
    y1: 39.6882,
    x2: 178.401,
    y2: 67.2834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11057_321499",
    x1: 5.46857,
    y1: 6.20786,
    x2: 5.46857,
    y2: 36.5355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11057_321499",
    x1: 74.2753,
    y1: 60.554,
    x2: 77.6485,
    y2: 102.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F95A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11057_321499",
    x1: 47.6698,
    y1: 71.0716,
    x2: 49.5347,
    y2: 128.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty_state.bc03aa8e386eed36de2894078afb9ccd.svg";
export { ForwardRef as ReactComponent };